import { render, staticRenderFns } from "./myCenter.vue?vue&type=template&id=b3d37052&scoped=true&"
import script from "./myCenter.vue?vue&type=script&lang=js&"
export * from "./myCenter.vue?vue&type=script&lang=js&"
import style0 from "./myCenter.vue?vue&type=style&index=0&id=b3d37052&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d37052",
  null
  
)

export default component.exports